import Skeleton from '@/components/ui/Skeleton'
import { cn } from '@/lib/utils'

/*
 * Skeleton pieces shared by the app family's pending pages (Home, Watchlist,
 * Alerts) and by the Home cards that draw the same shapes after the page has
 * committed. A light module on purpose: a route's `pendingComponent` is not
 * code-split, so whatever it imports ships in the entry chunk — Skeleton and
 * `cn`, and nothing with a chart or a modal in it.
 */

/** A bar vertically centred in a text line box of `line` height. */
export function Line({ line, bar, className }: { line: string; bar: string; className?: string }) {
  return (
    <div className={cn('flex items-center', line, className)}>
      <Skeleton className={cn('rounded-xs', bar)} />
    </div>
  )
}
